export const generateYAxesWithColors = (tags: any[], colors: string[]) => {
  if (tags.length === 0) return {};

  const yAxes: Record<string, any> = {};
  // eslint-disable-next-line @typescript-eslint/dot-notation
  yAxes['y'] = {
    type: 'linear',
    display: true,
    position: 'left',
    ticks: {
      color: colors[0],
    },
    grid: {
      drawOnChartArea: false,
    },
  };

  tags.slice(1).forEach((tag, index) => {
    const key = `y${index}`;
    const color = colors[index + 1];

    yAxes[key] = {
      type: 'linear',
      display: true,
      position: 'left',
      ticks: {
        color,
      },
      grid: {
        drawOnChartArea: false,
      },
    };
  });

  return yAxes;
};
